// Multiplier tiers per product line: [<600, 600-999, 1000-1999, 2000-2999, 3000-4000, 4000+]
const MULTIPLIER_TABLE: Record<string, number[]> = {
  '80 Series': [1.8, 1.65, 1.4, 1.3, 1.1, 1.0],
  Mezzo: [2.15, 2.0, 1.75, 1.65, 1.45, 1.35],
  International: [2.25, 2.1, 1.85, 1.75, 1.55, 1.45],
  Western: [2.45, 2.3, 2.05, 1.95, 1.75, 1.65],
  Impervia: [2.45, 2.3, 2.05, 1.95, 1.75, 1.65],
  'Anlin - Catalina': [2.45, 2.3, 2.05, 1.95, 1.75, 1.65],
  'Anlin - Panoramic': [2.45, 2.3, 2.05, 1.95, 1.75, 1.65],
  'Sliding Door': [2.45, 2.3, 2.05, 1.95, 1.75, 1.65],
}

const DEFAULT_MULTIPLIERS = [1.8, 1.65, 1.4, 1.3, 1.1, 1.0]

function getTierIndex(sqIn: number): number {
  if (sqIn < 600) return 0
  if (sqIn < 1000) return 1
  if (sqIn < 2000) return 2
  if (sqIn < 3000) return 3
  if (sqIn <= 4000) return 4
  return 5
}

export function getMultiplier(sqIn: number, productLine: string): number {
  if (sqIn <= 0) return 0
  const tiers = MULTIPLIER_TABLE[productLine] ?? DEFAULT_MULTIPLIERS
  return tiers[getTierIndex(sqIn)]
}

const MIN_WINDOW_PRICE = 2200

export function calculateBasePrice(
  width: number,
  height: number,
  productLine: string,
): number {
  const sqIn = width * height
  const raw = sqIn * getMultiplier(sqIn, productLine)
  if (raw <= 0) return 0
  return Math.max(raw, MIN_WINDOW_PRICE)
}

export function getMultiplierLabel(sqIn: number, productLine: string): string {
  if (sqIn <= 0) return ''
  const mult = getMultiplier(sqIn, productLine)
  return `×${mult.toFixed(2)}`
}

export interface SynchronyOption {
  name: string
  plan: number
  interestRate: number
  monthlyFactor: number
  termMonths: number
  dealerFeePercent: number
}

export const SYNCHRONY_OPTIONS: SynchronyOption[] = [
  {
    name: '0% Interest - 18 Months',
    plan: 924,
    interestRate: 0,
    monthlyFactor: 0.025,
    termMonths: 18,
    dealerFeePercent: 0.091,
  },
  {
    name: '7.99% Interest - 115 Months',
    plan: 942,
    interestRate: 7.99,
    monthlyFactor: 0.0125,
    termMonths: 115,
    dealerFeePercent: 0.1275,
  },
  {
    name: '3.99% Interest - 64 Months',
    plan: 960,
    interestRate: 3.99,
    monthlyFactor: 0.0175,
    termMonths: 64,
    dealerFeePercent: 0.1725,
  },
  {
    name: '0% Interest - 36 Months',
    plan: 931,
    interestRate: 0,
    monthlyFactor: 0.028,
    termMonths: 36,
    dealerFeePercent: 0.1745,
  },
  {
    name: '0% Interest - 60 Months',
    plan: 933,
    interestRate: 0,
    monthlyFactor: 0.0167,
    termMonths: 60,
    dealerFeePercent: 0.217,
  },
]

export type FinancingCompany = 'None' | 'Synchrony' | 'Hearth'
